import { render, staticRenderFns } from "./MessagesShowUser.vue?vue&type=template&id=852b93e0&scoped=true&"
import script from "./MessagesShowUser.vue?vue&type=script&lang=js&"
export * from "./MessagesShowUser.vue?vue&type=script&lang=js&"
import style0 from "./MessagesShowUser.vue?vue&type=style&index=0&id=852b93e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852b93e0",
  null
  
)

export default component.exports